import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBox,
  FDDisplayText,
  FDStack,
} from '@facet-wealth/design';
import { DataValueMap } from 'Helpers/Testing';
import { makeStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import useMobileLayout from 'Hooks/useMobileLayout';

const useStyles = makeStyles(theme => ({
  infoItemBullet: {
    color: theme.palette.facet.colorSunset500,
  },
  infoList: {
    paddingInlineStart: theme.spacing(2),
    margin: 0,
  },
}));

export default function FacetPlanProposalScenarioSelectionLearnMoreSection({ learnMoreSectionResource }) {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();
  return (
    <FDStack direction="column" spacing={8} {...DataValueMap.init('scenario-selection-intro-page-learn-more-section').build()}>
      <FDBox maxWidth={'900px'}>
        <FDDisplayText color="textSecondary" value={learnMoreSectionResource.attr('title')} />
      </FDBox>
      <FDStack direction={isMobile ? 'column' : 'row'} spacing={5}>
        <FDDisplayText color="textPrimary" value={learnMoreSectionResource.attr('subtitle')} size="sm" />
        <ul className={classes.infoList}>
          <FDStack direction={'column'} spacing={4}>
            {learnMoreSectionResource.attr('infoItems').map((item, index) => {
              // eslint-disable-next-line no-lone-blocks
              { /* Disabling linter rule because we have nothing better to use here as a key than the array index */ }
              // eslint-disable-next-line no-lone-blocks
              { /* eslint-disable-next-line react/no-array-index-key */ }
              return <li className={classes.infoItemBullet} key={index}> <Richtext value={item} richtext /> </li>;
            })}
          </FDStack>
        </ul>
      </FDStack>
    </FDStack>
  );
}

FacetPlanProposalScenarioSelectionLearnMoreSection.defaultProps = {
};

FacetPlanProposalScenarioSelectionLearnMoreSection.propTypes = {
  learnMoreSectionResource: PropTypes.object.isRequired,
};
